import {setupAxios} from '../app/modules/auth'
import {api} from './APIMiddlewares'
import API from './APIUrl'

  // form save api integration
  export async function addHoliday(InputField: {holidayName: string; date: string; isFloating: boolean}) {
    const {token, tenantId} = setupAxios()

    return await api
      .post(
        `/${API.HOLIDAY}`,
        token,
        tenantId,
        {
          body: JSON.stringify({
            name: InputField.holidayName,
            date: InputField.date,
            isFloating: InputField.isFloating,
          }),
        },
        false
      )
      .then((res) => res)
  }

  export async function getHolidaysByDateRange(InputField: {startDate: string; endDate: string}) {
    const {token, tenantId} = setupAxios()

    return await api
      .post(
        `/${API.HOLIDAY}/search`,
        token,
        tenantId,
        {
          body: JSON.stringify({
            startDate: InputField.startDate ? InputField.startDate + 'T00:00:00' : null,
            endDate: InputField.endDate ? InputField.endDate + 'T23:59:59' : null,
          }),
        },
        false
      )
      .then((res) => res)
  }
  //edit by id
  export async function updateHolidayById(
    InputField: {
      holidayName: string
      date: string
      isFloating: boolean
    },
    id: string
  ) {
    const {token, tenantId} = setupAxios()
    return await api
      .put(
        `/${API.HOLIDAY}/${id}`,
        token,
        tenantId,
        {
          body: JSON.stringify({
            name: InputField.holidayName,
            date: InputField.date,
            isFloating: InputField.isFloating,
          }),
        },
        false
      )
      .then((res) => res)
  }

  //   get Holiday
  export async function getHolidays() {
    const {token, tenantId} = setupAxios()
    return await api.get(`/${API.HOLIDAY}`, token, tenantId, false).then((res) => res)
  }

  //   delete holiday
  export async function deleteHolidays(id: string) {
    const {token, tenantId} = setupAxios()
    return await api.delete(`/${API.HOLIDAY}/${id}`, token, tenantId, false).then((res) => res)
  }

  //getHolidaybyid
  export async function getHolidaysById(id: string) {
    const {token, tenantId} = setupAxios()
    return await api.get(`/${API.HOLIDAY}/${id}`, token, tenantId, false).then((res) => res)
  }

  //Select Floating Holidays
  export async function selectFloatingHoliday(holidayIds: string[]) {
    const {token, tenantId} = setupAxios()
    return await api
      .post(
        `/floating-leave/select`,
        token,
        tenantId,
        {
          body: JSON.stringify({
            holidayIds,
          }),
        },
        false
      )
      .then((res) => res)
  }

  //Floating Holday Data show only Superadmin
  export async function getAllFloatingLeaves() {
    const {token, tenantId} = setupAxios()
    return await api
      .get(
        `/floating-leave/all`,
        token,
        tenantId,
        false
      )
      .then((res) => res)
  }

  // export async function removeFloatingHoliday(id: string) {
  //   const {token, tenantId} = setupAxios()
  //   return await api
  //     .delete(
  //       `/floating-leave/${id}`,
  //       token,
  //       tenantId,
  //       false
  //     )
  //     .then((res) => res)
  // }
  
// Remove Floating Holiday 
export async function removeFloatingHoliday(id: string) { 
  const {token, tenantId} = setupAxios() 
  return await api 
  .delete( 
    `/floating-leave/${id}`, 
    token, 
    tenantId,
    false 
  ) .then((res) => res
) }




